import { createContext, useCallback, useMemo, useState } from 'react';
import { useContextOrThrow } from '@elfsight/lib-utils';
import { noop } from 'es-toolkit';
import type { DefaultComponentProps } from '../types';

type PopupContextType = {
  isOpen: boolean;
  index: number;
  open: (nextIndex: number) => void;
  close: () => void;
};

const PopupContext = createContext<PopupContextType>({
  isOpen: false,
  index: -1,
  open: noop,
  close: noop
});

export function PopupProvider({ children }: DefaultComponentProps) {
  const [index, setIndex] = useState(-1);

  const open = useCallback((nextIndex: number) => {
    setIndex(nextIndex);
  }, []);
  const close = useCallback(() => {
    setIndex(-1);
  }, []);

  const value: PopupContextType = useMemo(
    () => ({ isOpen: index !== -1, index, open, close }),
    [index, open, close]
  );

  return (
    <PopupContext.Provider value={value}>{children}</PopupContext.Provider>
  );
}

export function usePopup() {
  return useContextOrThrow(PopupContext, 'Popup');
}
